import {call, put, takeLatest} from "redux-saga/effects";
import {
    ADD_VEHICLE,
    CHANGE_STATUS_VEHICLE,
    DELETE_VEHICLE,
    EDIT_VEHICLE,
    GET_VEHICLES,
    GET_VEHICLES_IDLES,
    GET_VEHICLES_IDLES_SUCCESS,
    GET_VEHICLES_LOCATIONS,
    GET_VEHICLES_LOCATIONS_SUCCESS,
    GET_VEHICLES_SUCCESS,
} from "./vehicles.types";
import {httpRequestsOnErrorsActions} from "../http_requests_on_errors";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {httpRequestsOnSuccessActions} from "../http_requests_on_success";
import {vehiclesService} from "./vehicles.service";

function* getVehicles({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(vehiclesService.getVehiclesService, payload?.params);

        yield put({
            type: GET_VEHICLES_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* addVehicle({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(vehiclesService.addVehicleService, payload.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editVehicle({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(vehiclesService.editVehicleService, payload?.id, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deleteVehicle({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(vehiclesService.deleteVehicleService, payload?.id);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* changeStatus({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(
            vehiclesService.changeStatusVehicleService,
            payload?.id,
            payload?.body,
        );

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getVehiclesIdles({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(vehiclesService.getVehiclesIdlesService, payload?.params);

        yield put({
            type: GET_VEHICLES_IDLES_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getVehiclesLocations({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(vehiclesService.getVehiclesLocationsService);

        yield put({
            type: GET_VEHICLES_LOCATIONS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        if (!payload?.noLoad) {
            yield put(httpRequestsOnLoadActions.removeLoading(type));
        }
    }
}

export const watchVehicles = function* watchVehicles() {
    yield takeLatest(GET_VEHICLES, getVehicles);
    yield takeLatest(ADD_VEHICLE, addVehicle);
    yield takeLatest(EDIT_VEHICLE, editVehicle);
    yield takeLatest(DELETE_VEHICLE, deleteVehicle);
    yield takeLatest(CHANGE_STATUS_VEHICLE, changeStatus);

    yield takeLatest(GET_VEHICLES_IDLES, getVehiclesIdles);

    yield takeLatest(GET_VEHICLES_LOCATIONS, getVehiclesLocations);
};
